import { render } from "./InfoPopup.vue?vue&type=template&id=be38bbf4"
import script from "./InfoPopup.vue?vue&type=script&lang=js"
export * from "./InfoPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__